module.exports = __webpack_public_path__ + "img/postAdVideo.6dc5eda0.png";